import { render, staticRenderFns } from "./salesStockReturn-add-or-update.vue?vue&type=template&id=a3b52ade&scoped=true"
import script from "./salesStockReturn-add-or-update.vue?vue&type=script&lang=js"
export * from "./salesStockReturn-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./salesStockReturn-add-or-update.vue?vue&type=style&index=0&id=a3b52ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b52ade",
  null
  
)

export default component.exports